export const gitVersion = '16e99fc47';
